import { render } from "./search-filter-salary.vue?vue&type=template&id=3188007c&scoped=true"
import script from "./search-filter-salary.vue?vue&type=script&lang=js"
export * from "./search-filter-salary.vue?vue&type=script&lang=js"

import "./search-filter-salary.vue?vue&type=style&index=0&id=3188007c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3188007c"]])

export default __exports__